import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaRegCircleUser, FaBars } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Button, Layout, Menu, theme } from "antd";
import scrollTop from "../helpers/scrollTop";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { BiSolidUserDetail } from "react-icons/bi";
import logo from "../assest/logo_nobg.png";
const { Header, Content } = Layout;

const AdminPanel = () => {
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = theme.useToken();

  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    const adminSession = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
    const adminStatus = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");

    if (
      !adminSession ||
      !adminStatus ||
      atob(adminSession) !== "ADMIN001" ||
      atob(adminStatus) !== "admin"
    ) {
      navigate("/employee-login");
    }
  }, [navigate]);

  useEffect(() => {
    setCollapsed(true);
  }, [location.pathname]);

  const handleLogout = () => {
    sessionStorage.removeItem("H7Z4L9VD2XK5JW8QRYT6");
    sessionStorage.removeItem("K3M8X1JQ5VZ4B7PWTL9");
    navigate("/employee-login");
  };

  const menuItems = [
    { key: "", icon: <AiOutlineUsergroupAdd />, label: "Dashboard" },
    {
      key: "services",
      icon: <BiSolidUserDetail />,
      label: "Services",
      children: [
        {
          key: "create-services",
          icon: <AiOutlineUsergroupAdd />,
          label: "Create Services",
        },
        {
          key: "all-services",
          icon: <AiOutlineUsergroupAdd />,
          label: "All Services",
        },
      ],
    },
       { key: "", icon: <AiOutlineUsergroupAdd />, label: "Patient Management" },
          { key: "", icon: <AiOutlineUsergroupAdd />, label: "Doctor Management" },
             { key: "", icon: <AiOutlineUsergroupAdd />, label: "Reports" },
                { key: "", icon: <AiOutlineUsergroupAdd />, label: "Messages" },
                   { key: "", icon: <AiOutlineUsergroupAdd />, label: "Settings" },

  ];

  // Improved key selection logic
  const selectedKey = (() => {
    const path = location.pathname.replace(/^\//, "");
    const flatKeys = menuItems.flatMap((item) => [
      item.key,
      ...(item.children || []).map((child) => child.key),
    ]);
    return (
      flatKeys.find((key) => path === key || path.startsWith(key + "/")) || ""
    );
  })();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <div
        style={{
          width: collapsed ? "0" : "250px",
          background: "#7bc1b7",
          color: "white",
          position: "fixed",
          height: "100vh",
          zIndex: 1000,
          paddingTop: "30px",
          transition: "width 0.3s ease",
          overflow: "hidden",
        }}
      >
        <div className="flex flex-col items-center p-4">
          <div className="text-3xl cursor-pointer">
            {user?.profilePic ? (
              <img
                src={user?.profilePic}
                className="w-12 h-12 rounded-full"
                alt={user?.name}
              />
            ) : (
              // <FaRegCircleUser className='text-white text-2xl' onClick={() => navigate('/')} />
              <img
                src={logo}
                className="w-[50%] h-[50%] rounded-full ml-[25%]"
              />
            )}
          </div>
          {!collapsed && (
            <p className="text-sm font-semibold text-white mt-2 uppercase">
              ADMIN
            </p>
          )}
        </div>

        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={["accounts"]}
          onClick={({ key }) => {
            navigate(`/${key}`);
            scrollTop();
            setCollapsed(true);
          }}
          style={{ backgroundColor: "#7bc1b7" }}
          className="custom-menu"
          items={menuItems.map((item) => ({
            ...item,
            label: item.label,
            icon: item.icon,
            children: item.children?.map((child) => ({
              ...child,
              label: <Link to={`/${child.key}`}>{child.label}</Link>,
            })),
          }))}
        />
      </div>

      {/* Main content */}
      <Layout
        style={{ marginLeft: collapsed ? "0" : "250px", minHeight: "100vh" }}
      >
        <Header
          style={{
            padding: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 16px",
            background: "#7bc1b7",
            position: "sticky",
            top: 0,
            zIndex: 1000,
          }}
        >
          <Button
            type="text"
            onClick={() => setCollapsed(!collapsed)}
            style={{
              backgroundColor: "transparent",
              color: "white",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            {collapsed ? <FaBars /> : <IoMdClose />}
          </Button>

          <div style={{ color: "white" }}>
            <h1 className="text-lg font-bold">SHLDR ADMIN PANEL</h1>
          </div>

          <Button
            type="text"
            onClick={handleLogout}
            style={{
              backgroundColor: "#7bc1b7",
              color: "white",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#7bc1b7")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#7bc1b7")
            }
          >
            Logout
          </Button>
        </Header>

        <Content
          style={{
            margin: "20px 16px",
            padding: 24,
            minHeight: 280,
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminPanel;
